export const getEtoZones = (obj) => ({
  type: "GET_ALL_ETO_ZONES",
  obj,
});

export const getEtoZonesSuccess = (data) => ({
  type: "GET_ALL_ETO_ZONES_SUCCESS",
  data,
});

export const getEtoZonesFail = (error) => ({
  type: "GET_ALL_ETO_ZONES_FAIL",
  error,
});

export const getZonesOfDistrict = (obj) => ({
  type: "GET_ZONES_OF_DISTRICT",
  obj,
});

export const getZonesOfDistrictSuccess = (data) => ({
  type: "GET_ZONES_OF_DISTRICT_SUCCESS",
  data,
});

export const getZonesOfDistrictFail = (error) => ({
  type: "GET_ZONES_OF_DISTRICT_FAIL",
  error,
});


export const resetAssignZonesToETO = (obj) => ({
  type: "RESET_ASSIGN_ZONES_TO_ETO",
  obj,
});

export const assignZonesToETO = (obj) => ({
  type: "ASSIGN_ZONES_TO_ETO",
  obj,
});

export const assignZonesToETOSuccess = (data) => ({
  type: "ASSIGN_ZONES_TO_ETO_SUCCESS",
  data,
});

export const assignZonesToETOFail = (error) => ({
  type: "ASSIGN_ZONES_TO_ETO_FAIL",
  error,
});
export const getZonesbyDistrict = (obj) => ({
  type: "ZONES_BY_DISTRICT",
  obj,
});

export const getZonesbyDistrictSuccess = (data) => ({
  type: "ZONES_BY_DISTRICT_SUCCESS",
  data,
});

export const getZonesbyDistrictFail = (error) => ({
  type: "ZONES_BY_DISTRICT_FAIL",
  error,
});
export const getDistrictCircles = (obj) => ({
  type: "GET_DISTRICT_CIRCLES",
  obj,
});

export const getDistrictCirclesSuccess = (data) => ({
  type: "GET_DISTRICT_CIRCLES_SUCCESS",
  data,
});

export const getDistrictCirclesFail = (error) => ({
  type: "GET_DISTRICT_CIRCLES_FAIL",
  error,
});
export const getHighwaysOfDistrict = (obj) => ({
  type: "GET_HIGHWAYS_OF_DISTRICT",
  obj,
});

export const getHighwaysOfDistrictSuccess = (data) => ({
  type: "GET_HIGHWAYS_OF_DISTRICT_SUCCESS",
  data,
});

export const getHighwaysOfDistrictFail = (error) => ({
  type: "GET_HIGHWAYS_OF_DISTRICT_FAIL",
  error,
});
export const editTableValues = (obj) => ({
  type: "EDIT_TABLE_VALUES",
  obj,
});

export const editTableValuesSuccess = (data) => ({
  type: "EDIT_TABLE_VALUES_SUCCESS",
  data,
});

export const editTableValuesFail = (error) => ({
  type: "EDIT_TABLE_VALUES_FAIL",
  error,
});
export const editHighwayValue = (obj) => ({
  type: "EDIT_HIGHWAY_VALUE",
  obj,
});

export const editHighwayValueSuccess = (data) => ({
  type: "EDIT_HIGHWAY_VALUE_SUCCESS",
  data,
});

export const editHighwayValueFail = (error) => ({
  type: "EDIT_HIGHWAY_VALUE_FAIL",
  error,
});
export const editZoneValue = (obj) => ({
  type: "EDIT_ZONE_VALUE",
  obj,
});

export const editZoneValueSuccess = (data) => ({
  type: "EDIT_ZONE_VALUE_SUCCESS",
  data,
});

export const editZoneValueFail = (error) => ({
  type: "EDIT_ZONE_VALUE_FAIL",
  error,
});
export const addDistrict = (obj) => ({
  type: "ADD_DISTRICT",
  obj,
});

export const addDistrictSuccess = (data) => ({
  type: "ADD_DISTRICT_SUCCESS",
  data,
});

export const addDistrictFail = (error) => ({
  type: "ADD_DISTRICT_FAIL",
  error,
});
